// extracted by mini-css-extract-plugin
export default {"root":"Download__root--Bp9nM"};